export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_03.2aae8e40.jpg";